import api from '@/utils/api';

const { baseApi } = window.GlobalConfig;

// 客户指标数据
export const QueryCustomerQuota = data => {
    return api.post(`${baseApi}/incomeTargetCustomer/getIncomeTargetCustomerListPage`, data);
};

export const DeleteCustomerQuota = ({}) => {
    return api.get(`${baseApi}`);
};

export const UpdateCustomerQuota = data => {
    return api.post(`${baseApi}/incomeTargetCustomer/saveIncomeTargetCustomer`, data);
};

//
export const UpdateStockQuota = data => {
    return api.post(`${baseApi}/incomeTargetCustomer/saveIncomeTargetCustomer`, data);
};

// 分配指标

export const QueryAssginQuota = data => {
    return api.post(`${baseApi}/incomeTargetArea/getIncomeTargetAreaTreeByControl`, data);
};

export const UpdateAssginQuota = data => {
    return api.post(`${baseApi}`, data);
};

export const QuerySaleUserByAreaId = data => {
    return api.post(`${baseApi}/incomeTargetUser/getIncomeTargetList4UserByArea`, data);
};

export const QueryViewQuota = data => {
    return api.post(`${baseApi}/incomeTargetArea/getIncomeTargetAreaTree`, data);
};

export const UpdateViewQuota = data => {
    return api.post(`${baseApi}/incomeTargetArea/saveIncomeTargetAreaBatch`, data);
};

export const SubmitQuotaStatus = data => {
    // return api.post(`${baseApi}/incomeTargetArea/updateIncomeTargetArea2LockBatch`, data);
    return api.post(`${baseApi}/incomeTargetArea/updateIncomeTargetAreaCommitFlag`, data);
};

export const SubmitUpdateStatus = data => {
    return api.post(`${baseApi}/incomeTargetArea/commitIncomeTargetArea`, data);
};

export const UpdateUserQuota = data => {
    return api.post(`${baseApi}/incomeTargetUser/saveIncomeTargetUserBatch`, data);
};

export const SubmitUserQuota = data => {
    return api.post(`${baseApi}/incomeTargetUser/commitIncomeTargetUser`, data);
};

export const SubmitUserQuotaStatus = data => {
    return api.post(`${baseApi}/incomeTargetUser/updateIncomeTargetUser2LockBatch`, data);
};

// 下属指标
export const QueryQuotaSub = data => {
    return api.post(`${baseApi}/incomeTargetUserMonth/getIncomeTargetUserMonthSubordinatePage`, data);
};

// 滚动指标
export const ScrollQuota = data => {
    return api.post(`/incomeTargetUserMonth/saveIncomeTargetUserMonthByPercentScroll`, data);
};

// 查询下级区域
export const QuerySubArea = data => {
    return api.post(`/incomeTargetAreaMonth/getIncomeTargetAreaMonth4Area`, data);
};

// 分配区域月指标
export const AssginAreaMonth = data => {
    return api.post(`/incomeTargetAreaMonth/saveIncomeTargetAreaMonthPercent`, data);
};

//
export const QueryAbnormalQuota = data => {
    return api.post(`/incomeTargetCustomerUnusual/getIncomeTargetCustomerUnusualPage`, data);
};

export const MarkMessage = data => {
    return api.post(`/incomeTargetCustomerUnusual/dealUnusual`, data);
};

//
export const CreateAbnormal = data => {
    return api.post(`/incomeTargetCustomerUnusual/addIncomeTargetCustomerUnusual`, data);
};

export const UpdateAbnormal = data => {
    return api.post(`/incomeTargetCustomerUnusual/updateIncomeTargetCustomerUnusual`, data);
};

export const DeleteAbnormal = () => {
    return api.post(``);
};

export const QueryAbnormalInfo = ({ customerId, year }) => {
    return api.get(`/incomeTargetCustomerUnusual/getIncomeTargetCustomerUnusual4Customer/${customerId}/${year}`);
};

export const AssginBaseQuota = data => {
    return api.post(`/incomeTargetCustomerYear/updateIncomeTargetCustomerByYearPercent`, data);
};
